<template>
  <main id="content">
    <section class="hero" style="margin:auto">
      <b-container style="margin-top:100px">
        <b-row>
          <b-col class="text-center">
            <span
              style="
            letter-spacing: 8.4px; color:#d5d5d5"
              >FAST AND RELIABLE</span
            >
            <h1 style="font-size:60px;" data-aos="fade-right">
              Centimeter-level accuracy.
            </h1>
            <p
              style="text-align: center; font-size:18px"
              data-aos="zoom-in-down"
            >
              Our cutting edge technology and services will help you outperform,
              outpace and overcome any obstacles in your way.<br />We provide
              innovative tools which will help you stay connected to your teams,
              clients and projects <br />
              from anywhere at any time. Build a reputation of trust by
              providing the safest, <br />
              fastest and most reliable mapping on the market.<br />
              Let us help you lead the way!
            </p>
            <div>
              <b-button
                type="button"
                class="btn btn-primary rounded-0 m-1 btn-lg animated bounce delay-2s"
                :to="'/about'"
                id="btnHomeScreenLearnMore"
              >
                Learn more
              </b-button>
              <b-button
                type="button"
                class="btn btn-outline-primary rounded-0 m-1 btn-lg"
                :to="'/contact'"
                id="btnHomeScreenGetInTouch"
                style="color:#fff; background-color:#ffffff00"
              >
                Get in touch
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="needle white">
      <b-container>
        <b-row>
          <b-col md>
            <div class="pr-md-4" data-aos="flip-right">
              <img src="../assets/needle_product.png" alt="Needle Products" />
            </div>
          </b-col>
          <b-col md>
            <div class="pr-md-8" data-aos="fade-up">
              <div
                class="text-uppercase mb-2"
                style="font-size: 16px; color:#00a8ff; font-weight:bold;"
              >
                Needle
              </div>
              <h2
                class="mb-1"
                style="font-size:25px; font-weight:bold;"
                data-aos="fade-up"
              >
                Mapping accuracy like never before.
              </h2>
              <div
                style="background: #00A8FF 0% 0% no-repeat padding-box;width: 70px;
height: 4px;opacity: 1; color:#00A8FF"
              ></div>
              <p style="margin-top:20px; text-align: left;" data-aos="fade-up">
                Needle is a versatile and rugged multi-GNSS RTK receiver. With
                centimeter-level precision in RTK mode. Needle has an incredible
                RTK engine at its core and is controlled using our state of the
                art cross-platform Needle app.
                <router-link :to="'/needle'">Read More</router-link>
              </p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="orbis black">
      <b-container>
        <b-row>
          <b-col md>
            <div
              class="pl-md-8"
              style="margin-top:30px"
              data-aos="fade-up-right"
            >
              <div
                class=" text-uppercase mb-2"
                style="font-size: 16px; color:#00a8ff; font-weight:bold;"
              >
                Orbis
              </div>
              <h2 style="margin-top:20px;" data-aos="fade-up-left">
                Map, mark, share, repeat.
              </h2>
              <div
                style="background: #00A8FF 0% 0% no-repeat padding-box;width: 70px;
height: 4px;opacity: 1; color:#00A8FF"
              ></div>
              <p
                style="margin-top:30px; text-align: left;"
                data-aos="fade-down-right"
              >
                Our intuitive multi-platform app lets you collect, aggregate,
                and share drilling data with your team in real-time. Never
                before has accurate data collection been this simple and
                accessible in the drilling industry. With a terabyte of cloud
                storage and offline data collection, you never have to worry
                about losing your data.
              </p>
              <a
                href="https://apps.apple.com/us/app/orbismaps/id1481563039"
                target="_blank"
              >
                <img
                  src="../assets/apple_playstore_white.svg"
                  alt="Orbis Maps"
                />
              </a>
              &nbsp; &nbsp;
              <a
                href="https://play.google.com/store/apps/details?id=com.drill.android"
                target="_blank"
              >
                <img
                  src="../assets/google_playstore_white.png"
                  height="39.9"
                  width="119"
                  alt="Orbis Maps"
                />
              </a>
            </div>
          </b-col>
          <b-col md>
            <div class="pl-md-4" data-aos="flip-left">
              <img src="../assets/needle_app.png" alt="Orbis App" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="dashboard white">
      <b-container>
        <b-row>
          <b-col md>
            <div class="pr-md-4" data-aos="flip-left">
              <img src="../assets/needle_dashboard.png" alt="Orbis Apps" />
            </div>
          </b-col>
          <b-col md>
            <div class="pr-md-8">
              <div
                class="text-uppercase mb-2"
                style="font-size: 16px; color:#00a8ff; font-weight:bold;"
                data-aos="fade-up"
              >
                Multi-Platform
              </div>
              <h2
                class="mb-1"
                style="font-size:40px; font-weight:bold;"
                data-aos="fade-up"
              >
                Cross-platform, accurate, and real-time.
              </h2>
              <div
                style="background: #00A8FF 0% 0% no-repeat padding-box;width: 70px;
height: 4px;opacity: 1; color:#00A8FF"
              ></div>
              <p
                style="margin-top:20px; text-align: left;"
                data-aos="flip-right"
              >
                Our intuitive multi-platform app lets you collect, aggregate,
                and share drilling data with your team in real-time. Never
                before has accurate data collection been this simple and
                accessible in the drilling industry. With a terabyte of cloud
                storage and offline data collection, you never have to worry
                about losing your data.
              </p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="services black">
      <b-container>
        <div class="row">
          <div class="col-md-12" style="margin-bottom:30px" data-aos="fade-up">
            <h2
              class="text-center"
              style="margin: 0in; margin-bottom:10px; color:#fff;"
              data-aos="fade-up"
            >
              OUR SERVICES
            </h2>
          </div>
          <div class="col-md-4">
            <div class="box-service" data-aos="flip-right">
              <img
                src="../assets/services/website.svg"
                alt="Website Building"
                class="center"
                style=" color:#fff;"
              />
            </div>
            <h4 class="text-center service_heading" data-aos="fade-up">
              Website Building
            </h4>
            <p class="text-center" style="color:#fff;" data-aos="fade-right">
              <span v-if="web_more_active">
                {{ web_text.slice(0, 140) }}
              </span>
              <a
                v-if="web_more_active"
                @click="activateReadMore('web')"
                class="u_link"
              >
                read more...
              </a>
              <span v-else>
                {{ web_text }}
              </span>
              <a
                v-if="!web_more_active"
                @click="activateReadLess('web')"
                class="u_link"
              >
                read less...
              </a>
            </p>
          </div>
          <div class="col-md-4">
            <div class="box-service" data-aos="flip-up">
              <img
                src="../assets/services/App.svg"
                alt="Application Building"
                class="center"
              />
            </div>
            <h4 class="text-center service_heading" data-aos="fade-right">
              Application Building
            </h4>
            <p class="text-center" style=" color:#fff" data-aos="fade-right">
              <span v-if="app_more_active">
                {{ app_text.slice(0, 140) }}
              </span>
              <a
                v-if="app_more_active"
                @click="activateReadMore('app')"
                class="u_link"
              >
                read more...
              </a>
              <span v-else>
                {{ app_text }}
              </span>
              <a
                v-if="!app_more_active"
                @click="activateReadLess('app')"
                class="u_link"
              >
                read less...
              </a>
            </p>
          </div>
          <div class="col-md-4">
            <div class="box-service">
              <img
                src="../assets/services/Seo.svg"
                alt="Digital Content Management"
                class="center"
                data-aos="flip-right"
              />
            </div>
            <h4 class="text-center service_heading" data-aos="fade-right">
              Digital Content Management
            </h4>
            <p class="text-center" style=" color:#fff" data-aos="fade-right">
              <span v-if="seo_more_active">
                {{ seo_text.slice(0, 140) }}
              </span>
              <a
                v-if="seo_more_active"
                @click="activateReadMore('seo')"
                class="u_link"
              >
                read more...
              </a>
              <span v-else>
                {{ seo_text }}
              </span>
              <a
                v-if="!seo_more_active"
                @click="activateReadLess('seo')"
                class="u_link"
              >
                read less...
              </a>
            </p>
          </div>
        </div>
      </b-container>
    </section>
    <section class="contact white">
      <b-container>
        <div class="row">
          <div class="col-md-7">
            <div class="contact-info" style="margin-top: 0in">
              <form class="js-form" novalidate="novalidate">
                <div class="row">
                  <div class="form-group col-sm-6" data-aos="fade-right">
                    <input
                      type="text"
                      name="name"
                      required=""
                      placeholder="Name*"
                      aria-required="true"
                      class="newadd form-control"
                      style="width: 95%;"
                    />
                  </div>
                  <div class="form-group col-sm-6" data-aos="fade-left">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      class="newadd form-control"
                    />
                  </div>
                  <div class="form-group col-sm-12" data-aos="fade-right">
                    <input
                      type="text"
                      name="subject"
                      placeholder="Company Name (optional)"
                      class="newadd form-control"
                    />
                  </div>
                  <div class="form-group col-sm-12" data-aos="fade-right">
                    <textarea
                      name="message"
                      required=""
                      placeholder="Message*"
                      aria-required="true"
                      style="height: 279px"
                      class="newadd form-control"
                      rows="10"
                    ></textarea>
                  </div>
                  <div class="col-sm-12">
                    <button
                      type="submit"
                      class="btn btn-black"
                      style="width: 230px; margin-top:10px"
                    >
                      Contact
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-5">
            <div>
              <GmapMap
                :center="{ lat: 47.609526517418864, lng: -122.13 }"
                :zoom="15"
                v-bind:options="mapStyle"
                map-type-id="roadmap"
                style="height: 300px; margin:10px; box-shadow: 3px 10px 18px #b5b5b5;"
              >
                <gmap-info-window
                  :position="{
                    lat: 47.609526517418864,
                    lng: -122.20772994999999
                  }"
                >
                  <div class="gmap-info text-center">
                    <h4 class="text-danger h2">
                      <font-awesome-icon icon="thumbtack" />
                    </h4>
                    <div>
                      100, 100
                      <sup>th</sup> Ave SE #1 <br />Bellevue WA, 98004
                    </div>
                  </div>
                </gmap-info-window>
              </GmapMap>
            </div>
            <div style="margin-left:10px; color: #5D6770">
              <p style="margin: 1px; margin-top:20px;">
                <i class="fa fa-map-marker"></i> 100, 100 Avenue SE #1,
                Bellevue, WA, 98004
              </p>
              <p style="margin: 1px; margin-top:5px;">
                <i class="fa fa-phone"></i> 425-457-2115
              </p>
              <p style="margin: 1px; margin-top:5px;">
                <i class="fa fa-envelope"></i> support@drillmaps.com
              </p>
            </div>
            <div
              style="margin-left:10px; margin-top:10px; color:#5D6770"
              class="row"
            >
              <div class="col-xs-1">
                <a href="https://www.facebook.com/DrillMaps">
                  <i class="fa fa-facebook" style="color:#5D6770"></i>
                </a>
              </div>
              <div class="col-xs-1" style="margin-left:15px;">
                <a href="https://twitter.com/DrillMaps">
                  <i class="fa fa-twitter" style="color:#5D6770"></i>
                </a>
              </div>
              <div class="col-xs-1" style="margin-left:15px;">
                <a href="https://in.linkedin.com/company/drill-maps">
                  <i class="fa fa-linkedin" style="color:#5D6770"></i>
                </a>
              </div>
              <div class="col-xs-1" style="margin-left:15px;">
                <a
                  href="https://www.youtube.com/channel/UCrtXZdqEgbkv4kejIW4eVDQ/"
                >
                  <i class="fa fa-youtube" style="color:#5D6770"></i>
                </a>
              </div>
              <div class="col-xs-1" style="margin-left:15px;">
                <a href="https://www.instagram.com/drillmaps/">
                  <i class="fa fa-instagram" style="color:#5D6770"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </b-container>
    </section>
    <Footer />
  </main>
</template>

<script>
import needleHeroImage from "../assets/needle-hero.png";
import auraMapviewImage from "../assets/aura-mapview.png";
import orbisHeroImage from "../assets/orbis-hero.png";
import Footer from "@/components/Footer.vue";

const resizeUtility = (imageHalf, imageHolder) => {
  if (imageHalf.classList.contains("image-half--right")) {
    imageHolder.style.right = 0;
  } else {
    imageHolder.style.left = 0;
  }
  if (window.innerWidth < 750) {
    imageHolder.style.width = "100vw";
    imageHolder.style.height = "60vw";
    imageHalf.parentNode.parentNode.style.paddingBottom = 0;
    imageHolder.style.position = "static";
    imageHolder.style.top = "auto";
    imageHolder.style.bottom = "auto";
  } else {
    imageHolder.style.position = "absolute";
    imageHolder.style.top = 0;
    imageHolder.style.bottom = 0;
    imageHalf.parentNode.parentNode.style.paddingBottom = "";
    imageHolder.style.width = "50%";
    imageHolder.style.height = "auto";
  }
  if (imageHalf.getAttribute("data-image-position")) {
    imageHolder.style.backgroundPosition = imageHalf.getAttribute(
      "data-image-position"
    );
    imageHolder.style.backgroundSize = "contain";
  } else {
    imageHolder.style.backgroundSize = "cover";
    if (window.innerWidth < 750) {
      imageHolder.style.marginTop = "4.5rem";
    } else {
      imageHolder.style.marginTop = 0;
    }
  }
};
export default {
  data: () => {
    return {
      needleHeroImage,
      auraMapviewImage,
      orbisHeroImage,
      web_text:
        "Our team of experts works with you to develop a customized cloud-based website that will fit to your specific business model needs. We build content that drives audiences to your services making it easier for you to connect with your customer base and track projects and deliverables. We offer ongoing technical support to ensure your focus remains on doing business and providing the best service possible. Let us help you connect!",
      web_more_active: true,
      app_text:
        "We know how important it is to have good data at your fingertips. That’s why we work specifically to customize and build an app that provides the tools and information you need to always stay connected. With a cloud-based app and syncing capabilities we help you drill down to the data that matters, providing you and your team with the resources you need on-the-go.",
      app_more_active: true,
      seo_text:
        "We help streamline your process flow by converting all your paper-based data collection into digital content that is readily available and easy to access at any time. Using AI technology, we quickly and accurately scan all your paper-based documentation into our database to produce Google and 3D maps which help you visualize, track and share your projects in real-time. We bring your content to the digital age thus saving you precious time, money and resources and ensuring your business runs smoothly.",
      seo_more_active: true,
      mapStyle: {
        mapTypeControl: false,
        zoomControl: false,
        width: 400,
        height: 300,
        marigin: 10,
        styles: [
          { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#f5f5f5" }]
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{ color: "#bdbdbd" }]
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#eeeeee" }]
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }]
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#d8ebd4" }]
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }]
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }]
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }]
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }]
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }]
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#cedfe0" }]
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }]
          }
        ]
      }
    };
  },
  mounted: function() {
    const imageHalves = document.querySelectorAll(".image-half");
    [].forEach.call(imageHalves, function(imageHalf) {
      imageHalf.parentNode.parentNode.style.position = "relative";
      const imageHolder = document.createElement("div");
      imageHolder.classList.add("vue-image-holder");
      imageHolder.style.backgroundRepeat = "no-repeat";
      if (imageHalf.getAttribute("data-image-url")) {
        imageHolder.style.backgroundImage =
          "url(" + imageHalf.getAttribute("data-image-url") + ")";
      }
      resizeUtility(imageHalf, imageHolder);
      imageHalf.appendChild(imageHolder);
    });
  },
  methods: {
    activateReadMore(type) {
      if (type == "web") {
        this.web_more_active = false;
      }
      if (type == "app") {
        this.app_more_active = false;
      }
      if (type == "seo") {
        this.seo_more_active = false;
      }
    },
    activateReadLess(type) {
      if (type == "web") {
        this.web_more_active = true;
      }
      if (type == "app") {
        this.app_more_active = true;
      }
      if (type == "seo") {
        this.seo_more_active = true;
      }
    }
  },
  components: {
    Footer
  }
};
window.addEventListener("resize", () => {
  const imageHalves = document.querySelectorAll(".image-half");
  [].forEach.call(imageHalves, function(imageHalf) {
    const imageHolder = imageHalf.querySelector(".vue-image-holder");
    imageHolder && resizeUtility(imageHalf, imageHolder);
  });
});
</script>
<style lang="scss" scoped>
section {
  &.hero {
    color: #fff;
    background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.8),
        rgba(0, 0, 0, 0.4)
      ),
      url("../assets/bg1.png") no-repeat center center;
    background-size: cover;
    p {
      margin: 1rem 0 1.75rem 0;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
}
</style>
<style>
.artibot-wrapper--19YJW {
  display: show;
}
.box-service {
  height: 100px;
  margin: 10px;
  align-items: flex-end;
  display: flex;
}
.u_link {
  text-decoration: underline solid #007ebf;
  color: #00a8ff !important;
  cursor: -webkit-grab;
  cursor: grab;
}
.service_heading {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
